module.exports = __webpack_public_path__ + "img/铆钉狗狗.480fae0d.png";